import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { ROUTES } from '@/config/routes'
import { useUser } from '@/contexts/UserContext'

interface IPrivateRouteProps {
  allowedProfiles?: string[]
}

export const PrivateRoute: React.FC<IPrivateRouteProps> = ({
  allowedProfiles = [],
}) => {
  const { userProfile, isLoading: userLoading, hasAccess } = useUser()

  if (userLoading) return null

  if (!hasAccess) {
    return <Navigate to={ROUTES.ACCESS_DENIED} replace />
  }

  if (
    allowedProfiles.length > 0 &&
    !allowedProfiles.includes(userProfile || '')
  ) {
    return <Navigate to={ROUTES.ACCESS_DENIED} replace />
  }

  return <Outlet />
}
